module.exports = __webpack_public_path__ + "img/sketch_full.d6e84f5b.jpg";